import * as angular from 'angular';
import {IHttpService, ILogService, IQService} from 'angular';
import TSDokument from '../../models/TSDokument';
import {TSDocumentType} from '../../models/enums/TSDokumentType';

import IPromise = angular.IPromise;

export class UploadRS {
    serviceURL: string;
    http: IHttpService;
    log: ILogService;
    q: IQService;

    static $inject = ['$http', 'REST_API', '$log', 'Upload', '$q', 'base64'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, $log: ILogService, private upload: any,
                $q: IQService, private base64: any) {
        this.serviceURL = REST_API + 'upload/typed';
        this.http = $http;
        this.log = $log;
        this.q = $q;
    }

    public uploadFile(files: any, fallId: string, parentId?: string, doctype?: TSDocumentType): IPromise<TSDokument[]> {

        let names: string [] = [];
        for (let file of files) {
            if (file) {
                let encodedFilename = this.base64.encode(file.name);
                names.push(encodedFilename);
            }
        }

        return this.upload.upload({
            url: this.serviceURL,
            method: 'POST',
            headers: {
                'x-filename': names.join(';'),
            },
            data: {
                file: files,
                fallId: fallId,
                parentId: parentId,
                doctype: doctype,
            }
        }).then((response: any) => {
            this.log.debug('PARSING dokumentDTO REST object ', response.data);
            let converter = (jsonString: any) => {
                return new TSDokument().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        }, (response: any) => {
            console.log('Upload File: NOT SUCCESS');
            return this.q.reject();
        }, (evt: any) => {
            let loaded: number = evt.loaded;
            let total: number = evt.total;
            let progressPercentage: number = 100.0 * loaded / total;
            console.log('progress: ' + progressPercentage + '% ');
            return this.q.defer().notify();
        });
    }

    public getServiceName(): string {
        return 'UploadRS';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/uploadRS.rest.ts